import { useState } from "react";
import useGetSpecialties from "src/hooks/useGetSpecialtyBasedOnStack";
import useGetStacks from "src/hooks/useGetStacks";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";
import { StepStyleSection } from "../../layout";
import LoadingSpinner from "src/components/Loader/LoadingSpinner";
import ErrorBox from "../../components/ErrorBox";
import { CheckboxItem } from "../../components/check/checkbox";
import ButtonSpinner from "src/components/Loader/ButtonSpinner";
import EmptypBox from "../../components/EmptyBox";
import { toast } from "react-toastify";
import { useEffect } from "react";
import NewSpecialty from "./NewSpecialty";
import AddNewSpecialty from "./AddNewSpecialty";

export default function SelectSpecialty({
  errorMessage,
}) {
  const { userStack, userJobType, userLanguages, updateUserLanguages, updateUserStack } = useClientSignUpSteps();
  const maxSelection = 3;

  const { stacks } = useGetStacks();
  const isCustomStack = userStack && userStack !== 'other' && stacks && stacks.length > 0 && !stacks.some(s => s.id === userStack);

  const { loading, error, specialties, retry } = useGetSpecialties(userStack);

  const [showOtherInput, setShowOtherInput] = useState(userJobType === "non-tech");
  const [showAddOtherInput, setShowAddOtherInput] = useState(userStack === 'other');

  useEffect(() => {
    if (userStack === 'other') {
      setShowAddOtherInput(true);
      setShowOtherInput(false);
    } else {
      setShowAddOtherInput(false);
    }
  }, [userStack]);

  useEffect(() => {
    if (isCustomStack) {
      setShowOtherInput(true);
    }
  }, [isCustomStack]);

  useEffect(() => {
    if (!loading && (error || specialties.length === 0) && userStack && isCustomStack) {
      setShowOtherInput(true);
    }
  }, [loading, error, specialties, userStack, isCustomStack]);


  return (
    <StepStyleSection isInvalid={errorMessage != null}>
      <div className="flex flex-col gap-4">
        {/* Header with Counter */}
        <div className="flex justify-between items-center border-b border-gray-100 pb-2">
          <p className="text-semibold ">
          { showAddOtherInput ? "Add Specialty" : "Select Specialties" }</p>

          <div className="text-xs text-bold  px-2 py-1 rounded-lg">
            {userLanguages.length} / {maxSelection}
          </div>
        </div>

        {loading && <LoadingSpinner />}

        {!loading && error && !showAddOtherInput && <ErrorBox message={`${error}`} onRetry={retry} />}

        {!loading && (
          <div className="flex flex-col gap-2">

            <div className="flex flex-wrap gap-2 items-center">
              <CheckboxItem
                key={'other'}
                selected={showOtherInput}
                className={`${showAddOtherInput ? "bg-brand-navy text-white" : "border border-brand-navy bg-white text-brand-navy"} hidden`}
                onSelect={() => {
                  setShowOtherInput(false);
                  setShowAddOtherInput(!showAddOtherInput);
                }}
              >
                Other
              </CheckboxItem>

              {/* Render Custom Selected Specialties */}
              {userLanguages.filter(lang => lang.id.toString().startsWith('custom-')).map((customLang) => (
                <CheckboxItem
                  key={customLang.id}
                  selected={true}
                  onSelect={() => {
                    updateUserLanguages(userLanguages.filter(each => each.id !== customLang.id))
                  }}
                >
                  {customLang.name}
                </CheckboxItem>
              ))}

              {!error && !showAddOtherInput && specialties.map((specialty, index) => {
                const selected = userLanguages.find(each => each.id === specialty.id)

                return (
                  <CheckboxItem
                    key={specialty.id}
                    selected={selected}
                    onSelect={() => {
                      if (selected) {
                        updateUserLanguages(userLanguages.filter(each => each.id !== selected?.id))

                        // updateUserStack(undefined);
                      } else if (userLanguages.length === maxSelection) {
                        toast.info('You have selected maximum number of Languages')
                      } else {
                        updateUserLanguages(
                          [...userLanguages, {
                            id: specialty.id,
                            experience: undefined,
                            name: specialty?.name,
                          }])

                        // updateUserStack(specialty.name);
                      }
                    }}
                  >
                    {specialty.name}
                  </CheckboxItem>
                );
              })}
            </div>

            {!error && specialties.length < 1 && !isCustomStack && !showAddOtherInput && (
              <EmptypBox message={"No specialties found"} />
            )}

            {isCustomStack && (
              <div className="mt-2">
                {showOtherInput && <NewSpecialty isNested={true} />}
              </div>
            )}
            {!showOtherInput && showAddOtherInput && <AddNewSpecialty />}
          </div>
        )}
      </div>
    </StepStyleSection>
  );
}
